/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlayerOverridesViewModelResult } from '../../models/player-overrides-view-model-result';

export interface ApiPlayerOverridesIdGet$JsonOdataMetadataFullOdataStreamingTrue$Params {
  id: number;
}

export function apiPlayerOverridesIdGet$JsonOdataMetadataFullOdataStreamingTrue(http: HttpClient, rootUrl: string, params: ApiPlayerOverridesIdGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerOverridesViewModelResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlayerOverridesIdGet$JsonOdataMetadataFullOdataStreamingTrue.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=full;odata.streaming=true', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlayerOverridesViewModelResult>;
    })
  );
}

apiPlayerOverridesIdGet$JsonOdataMetadataFullOdataStreamingTrue.PATH = '/api/player/overrides/{id}';
